import indexOf from 'lodash/indexOf';

import store from '../../store';

import { MORTGAGE_BROKER } from '../../constants/contact_id_status';
import { TRUST_DEED2, TRUST_DEED3 } from '../../constants/pms_lien_position';
import { PURCHASE } from '../../constants/pms_purpose_of_loan';
import { CONSTRUCTION, FIX_FLIP, TDS } from '../../constants/typeOfHomeOptions';
import { REQUIRED } from '../../constants/validations';

const validations = values => {
  let errors = {};

  const { accounts, contacts } = store.getState().form;
  const { purpose_of_loan } = store.getState().consoleBrok1;

  if (!values.purchase_price) {
    errors.purchase_price = REQUIRED;
  }

  if (!values.purchase_date) {
    errors.purchase_date = REQUIRED;
  }

  if (!values.as_is_value) {
    errors.as_is_value = REQUIRED;
  }

  if (purpose_of_loan === PURCHASE.value) {
    if (!values.purchase_status) {
      errors.purchase_status = REQUIRED;
    }

    if (!values.prchs_trnsctn_type) {
      errors.prchs_trnsctn_type = REQUIRED;
    }
  }

  if (accounts.type_of_loan === FIX_FLIP.value || accounts.type_of_loan === CONSTRUCTION.value) {
    if (!values.arv_market_value) {
      errors.arv_market_value = REQUIRED;
    }

    if (!values.rehab_amount) {
      errors.rehab_amount = REQUIRED;
    }

    if (!values.sq_ft_addition) {
      errors.sq_ft_addition = REQUIRED;
    }
  }

  if (!values.loan_amount) {
    errors.loan_amount = REQUIRED;
  }

  if (!values.lien_position) {
    errors.lien_position = REQUIRED;
  }

  if (!values.loan_terms) {
    errors.loan_terms = REQUIRED;
  }

  if (!values.interest_rate) {
    errors.interest_rate = REQUIRED;
  }

  if (contacts.id_status === MORTGAGE_BROKER.value) {
    if (!values.broker_points) {
      errors.broker_points = REQUIRED;
    }

    if (!values.broker_processing_fee_5) {
      errors.broker_processing_fee_5 = REQUIRED;
    }
  }

  if (accounts.type_of_loan === TDS.value) {
    if (
      indexOf([TRUST_DEED2.value, TRUST_DEED3.value], values.lien_position) !== -1 &&
      !values['1st_td_amount']
    ) {
      errors['1st_td_amount'] = REQUIRED;
    }

    if (indexOf([TRUST_DEED3.value], values.lien_position) !== -1 && !values['2nd_td_amount']) {
      errors['2nd_td_amount'] = REQUIRED;
    }
  }

  return errors;
};

export default validations;



// WEBPACK FOOTER //
// ./src/Screens/ConsoleBrok/validations2.js